var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{on:{"click":_vm.goTo}},[_vm._v("欢迎使用盘口调度平台")])])
}
var staticRenderFns = []

export { render, staticRenderFns }